<template>
	<div class="page-turn">
        <div class="pagination">
            <span class="pre" v-show="curPage > 1" @click="loadPage(curPage - 1)"></span>
            <span v-for="item in pageSum" :key="item" :class="['page-num', {'active': curPage === item}]" @click="loadPage(item)" v-show="showPage(item)">
                {{ item }}
            </span>
            <span class="next" v-show="curPage < pageSum" @click="loadPage(curPage + 1)"></span>
        </div>
	</div>
</template>

<script>
import ajax from '@/api/ajax'
export default {
    name: 'pageTurn',
    props: {
        pageSum: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            curPage: 1
        }
    },
	watch:{
		pageSum: function() {
			this.curPage = 1
		}
	},
    created() {
	},
    methods: {
        showPage(item) {
            const limit = 3
            if(this.curPage < limit && item < limit * 2) return true
            if((this.pageSum - this.curPage < limit) && (item > (this.pageSum - limit * 2 + 1))) return true
            if(Math.abs(item - this.curPage) < limit) return true
        },
        loadPage(page) {
            this.curPage = page
            this.$emit('on-turn', {
                page
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.page-turn {
    .pagination {
        display: flex;
        padding: 0 .2rem;
        padding-bottom: .4rem;
        justify-content: center;
        align-content: center;
        .page-num {
            display: inline-block;
            text-align: center;
            font-size: .36rem;
            color: #333333;
            margin: 0 .2rem;
        }
        .pre {
            display: inline-block;
            height: .54rem;
            margin: 0 .2rem;
            background-image: url('~@/assets/images/promotion/btn-prev.png');
            background-repeat: no-repeat;
            background-position: center;
            width: 0.4rem;
            background-position-x: 0;
        }
        .next {
            display: inline-block;
            height: .54rem;
            margin: 0 .2rem;
            width: 0.4rem;
            background-image: url('~@/assets/images/promotion/btn-prev.png');
            background-repeat: no-repeat;
            background-position: center;
            background-position-x: right;
        }
        .active {
            text-decoration: underline;
            color: #dc1e32;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page-turn/index.vue